<template>
  <div class="containner-buslog p-1 page-break-inside-avoid">
    <div class="flex items-center justify-between">
      <img
        src="/images/shipment/melhorenvio/logo.svg"
        alt="Melhor Envio"
        width="84"
        height="39"
      >

      <img
        src="/images/shipment/buslog/logo-negativo.svg"
        alt="Comprovante de Postagem"
        width="84"
        height="27"
      >
    </div>

    <h2 class="mt-2 mb-4 text-lg font-bold text-center uppercase">Comprovante de Postagem</h2>

    <div class="mb-4 text-xs">
      <div class="flex items-center gap-4 mb-1">
        <div class="flex flex-1 gap-1">
          <p>Unidade de postagem:</p>
          <p class="flex-1 border-b border-black"></p>
        </div>

        <div class="flex flex-0 gap-1">
          <p>Data: </p>
          <p class="flex">
            <p class="w-5 border-b border-black"></p>
            <p>/</p>
            <p class="w-5 border-b border-black"></p>
            <p>/</p>
            <p class="w-8 border-b border-black"></p>
          </p>
        </div>
      </div>

      <p>Objetos postados (preencha os espaços com o rastreio dos objetos)</p>
    </div>

    <table class="w-full mb-4">
      <tr v-for="row in rows" :key="row">
        <td
          v-for="column in columns" :key="column"
          class="h-7 border-1 border-black"
        />
      </tr>
    </table>

    <h2 class="my-6 text-xs font-bold text-center uppercase">ATENÇÃO</h2>

    <div class="text-xs">
      <p class="text-buslog-comprovante">
        Por este documento, informo que estou deixando uma(s) encomenda(s)
        para embarque no balcão da BUSLOG <span class="font-bold">sem a emissão do CTe</span> (Conhecimento de
        Transporte Eletrônico) e <span class="font-bold">sem conferência por parte da transportadora.</span>
      </p>

      <p class="pt-4 text-buslog-comprovante">
        Caso haja irregularidades que impeçam o embarque e transporte da(s) carga(s)
        - como embalagem inadequada, produtos não permitidos, falta ou
        documentação irregular, entre outros - a mercadoria <span class="font-bold">não será embarcada.</span>
      </p>

      <p class="pt-4 text-buslog-comprovante">
        Após correções e ajustes, e sendo possível a regularização, a encomenda será
        embarcada. Não sendo possível a correção e ajuste, a encomenda ficará
        disponível para retirada no local onde foi deixada por <span class="font-bold">até 10 dias úteis.</span>
      </p>
    </div>

    <div class="my-6 text-xs">
      <div class="flex gap-1 mb-4">
        <p class="font-bold">Assinatura do recebedor:</p>
        <p class="flex-1 border-b border-black"></p>
      </div>

      <div class="flex gap-1 mb-4">
        <p class="font-bold">Nome legível:</p>
        <p class="flex-1 border-b border-black"></p>
      </div>

      <div class="flex gap-1 mb-lg">
        <p class="font-bold">Telefone da unidade:</p>
        <p class="flex-1 border-b border-black"></p>
      </div>

      <div class="flex gap-1 mb-4">
        <p class="font-bold">Assinatura do cliente:</p>
        <p class="flex-1 border-b border-black"></p>
      </div>

      <div class="flex gap-1 mb-4">
        <p class="font-bold">Nome legível:</p>
        <p class="flex-1 border-b border-black"></p>
      </div>

      <div class="flex gap-1 mb-4">
        <p class="font-bold">Telefone:</p>
        <p class="flex-1 border-b border-black"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rows: 4,
      columns: 2,
    }
  }
};
</script>

<style scoped>
.containner-buslog {
  width: 445px;
  margin: 60px auto;
}

.text-buslog-comprovante {
  font-weight: 400;
  text-align: justify;
  font-style: normal;
  line-height: normal;
}

.mb-lg {
  margin-bottom: 40px;
}

@media print {
  .containner-buslog {
    padding: 8mm;
  }
}
</style>

